import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

module.exports = {
    ...storeModuleFactory({
        name:               'billingAlertsStates',
        endpoint:           endpoints.billingAlerts.endpointAlertsStates,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
        transformResultsFn: json => json
    })
};





// WEBPACK FOOTER //
// ./src/modules/store/billingAlertsStates.js